// extracted by mini-css-extract-plugin
export default {"zoomControls":"ida-z","zoomControlButton":"jda-z","zoomBanner":"kda-z","bannerButton":"lda-z","imageButton":"mda-z","zoom":"nda-z","zoomContent":"oda-z"};